import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=503bc560&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=503bc560&prod&scoped=true&lang=css"
import style1 from "./Course.vue?vue&type=style&index=1&id=503bc560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bc560",
  null
  
)

export default component.exports